import styled from "styled-components";
import { Colors } from "../../config";

const BizTripHomePassengerDetails = ({ name }) => {
  return (
    <Container>
      <PassengerName>Hi {name} </PassengerName>
      <InfoText>
        <RedSpan>Planning a business trip? </RedSpan>
        Apply for Business Trip leave, per diem, and travel requests and manage
        your trip seamlessly from a single platform.
      </InfoText>
    </Container>
  );
};

export default BizTripHomePassengerDetails;

// Styled Components

const Container = styled.div`
  // padding: 1rem;
`;

const PassengerName = styled.div`
  font-size: 2.25rem;
  font-weight: 600;
  color: ${Colors.gray92};
  margin: 1rem 0;
`;

const InfoText = styled.div`
  font-size: 16px;
  color: ${Colors.gray};
`;

const RedSpan = styled.span`
  color: ${Colors.red};
`;
